export const firstLetterUpperCase = (title: string) => title.split('')[0].toUpperCase() + title.slice(1, title.length);

export const zoneCompare = (zone: number, zoneCmp: number) =>
{
    return Math.sign(zone - zoneCmp);
};